import { IComboBase } from '../interfaces/base/base.interface';

export const monthOptions: IComboBase[] = [
  { key: '01', text: 'Enero' },
  { key: '02', text: 'Febrero' },
  { key: '03', text: 'Marzo' },
  { key: '04', text: 'Abril' },
  { key: '05', text: 'Mayo' },
  { key: '06', text: 'Junio' },
  { key: '07', text: 'Julio' },
  { key: '08', text: 'Agosto' },
  { key: '09', text: 'Septiembre' },
  { key: '10', text: 'Octubre' },
  { key: '11', text: 'Noviembre' },
  { key: '12', text: 'Diciembre' },
];

// Función para obtener nombre del mes por número (1-12)
export const getMonthName = (monthNumber: number): string => {
  const month = monthOptions.find((m) => parseInt(m.key) === monthNumber);
  return month ? month.text.toLowerCase() : ''; // Añade .toLowerCase() aquí
};

// Obtener año actual, año anterior, año posterior
export const getYearOptions = (): IComboBase[] => {
  const currentYear = new Date().getFullYear();
  const years: IComboBase[] = [];

  for (let i = currentYear - 5; i <= currentYear + 1; i++) {
    years.push({
      key: i.toString(),
      text: i.toString(),
    });
  }

  return years;
};

// export const getYearOptions = (): IComboBase[] => {
//   const currentYear = new Date().getFullYear();
//   const years = [currentYear - 1, currentYear, currentYear + 1];

//   return years.map((year) => ({
//     key: year.toString(),
//     text: year.toString(),
//   }));
// };

// Función para convertir números a texto (hasta 999)
export const numberToText = (num: number): string => {
  if (num < 0 || num > 999) {
    return 'Número fuera de rango';
  }

  const units = [
    '',
    'uno',
    'dos',
    'tres',
    'cuatro',
    'cinco',
    'seis',
    'siete',
    'ocho',
    'nueve',
  ];
  const tens = [
    '',
    'diez',
    'veinte',
    'treinta',
    'cuarenta',
    'cincuenta',
    'sesenta',
    'setenta',
    'ochenta',
    'noventa',
  ];
  const teens = [
    'diez',
    'once',
    'doce',
    'trece',
    'catorce',
    'quince',
    'dieciséis',
    'diecisiete',
    'dieciocho',
    'diecinueve',
  ];
  const hundreds = [
    '',
    'ciento',
    'doscientos',
    'trescientos',
    'cuatrocientos',
    'quinientos',
    'seiscientos',
    'setecientos',
    'ochocientos',
    'novecientos',
  ];

  // Casos especiales
  if (num === 0) return 'cero';
  if (num === 100) return 'cien';

  let result = '';

  // Centenas
  const hundred = Math.floor(num / 100);
  if (hundred > 0) {
    result += hundreds[hundred];
    num %= 100;
    if (num > 0) result += ' ';
  }

  // Decenas y unidades
  if (num > 0) {
    if (num < 10) {
      result += units[num];
    } else if (num >= 10 && num < 20) {
      result += teens[num - 10];
    } else {
      const ten = Math.floor(num / 10);
      const unit = num % 10;
      result += tens[ten];
      if (unit !== 0) {
        // Casos especiales para 21-29 (veintiuno, veintidós, etc.)
        if (ten === 2) {
          result = result.slice(0, -1) + 'i' + units[unit]; // "veinte" -> "veinti"
        } else {
          result += ' y ' + units[unit];
        }
      }
    }
  }

  return result;
};

// Extraer nombre del documento
export const extractFileName = (fileUrl: string): string => {
  if (!fileUrl) return 'documento.pdf'; // Valor por defecto

  try {
    const cleanUrl = fileUrl.split('?')[0];

    const uuidPattern =
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;
    const lastDashIndex = cleanUrl.search(uuidPattern);

    if (lastDashIndex === -1) {
      return cleanUrl.split('/').pop() || 'documento.pdf';
    }

    let fileName = cleanUrl.substring(lastDashIndex + 37); // 36 caracteres UUID + 1 guion
    fileName = fileName.replace(/&/g, ' ');

    return fileName || 'documento.pdf';
  } catch (error) {
    console.error('Error al extraer nombre de archivo:', error);
    return 'documento.pdf';
  }
};

// Texto día, días
export const getDayLabel = (days: number): string => {
  return days === 1 ? 'día' : 'días';
}
